import {
  SURVEYSCORE_LOADING,
  GET_SURVEYSCORE,
  GET_SURVEYSCORE_SUCCESS,
  GET_SURVEYSCORE_FAIL,
  ADD_SURVEYSCORE_SUCCESS,
  ADD_SURVEYSCORE_FAIL,
  DELETE_SURVEYSCORE_SUCCESS,
  DELETE_SURVEYSCORE_FAIL,
  UPDATE_SURVEYSCORE_SUCCESS,
  UPDATE_SURVEYSCORE_FAIL,
  SURVEYSCORE_RESET,
  SURVEYSCORE_RESET_CREATE,
} from "./actionType";

const INIT_STATE = {
  surveyScores: [],
  surveyScoreAdded: {},
  error: {},
};

const SurveyScore = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SURVEYSCORE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SURVEYSCORE:
          return {
            ...state,
            surveyScores: action.payload.data,
            isSurveyScoreCreated: false,
            isSurveyScoreSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_SURVEYSCORE_FAIL:
      switch (action.payload.actionType) {
        case GET_SURVEYSCORE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isSurveyScoreCreated: false,
            isSurveyScoreSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_SURVEYSCORE: {
      return {
        ...state,
        isSurveyScoreCreated: false,
        loading: true,
      };
    }

    case SURVEYSCORE_LOADING: {
      return {
        ...state,
        isSurveyScoreCreated: false,
        loading: true,
      };
    }

    case ADD_SURVEYSCORE_SUCCESS:
      return {
        ...state,
        isSurveyScoreCreated: true,
        loading: false,
        surveyScores: [action.payload.data, ...state.surveyScores],
        surveyScoreAdded: action.payload.data,
      };

    case ADD_SURVEYSCORE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_SURVEYSCORE_SUCCESS:
      return {
        ...state,
        loading: false,
        surveyScores: state.surveyScores.filter(
          (surveyScore) =>
            surveyScore.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_SURVEYSCORE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SURVEYSCORE_SUCCESS:
      return {
        ...state,
        loading: false,
        surveyScores: state.surveyScores.map((surveyScore) =>
          surveyScore.id.toString() === action.payload.data.id.toString()
            ? { ...surveyScore, ...action.payload.data }
            : surveyScore
        ),
      };

    case UPDATE_SURVEYSCORE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SURVEYSCORE_RESET_CREATE:
      return {
        ...state,
        isSurveyScoreCreated: false,
      };

    case SURVEYSCORE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default SurveyScore;
